import { combineReducers } from '@reduxjs/toolkit';
import employeeReducer from '@store/slices/employeeSlice';
import configurationReducer from '@store/slices/configurationSlice';
import orderReducer from '@store/slices/orderSlice';
import vehicleConfigurationReducer from '@store/slices/vehicleConfigurationSlice';
import vehicleStockReducer from '@store/slices/vehicleStockSlice';
import usedVehicleStockReducer from '@store/slices/usedVehicleStockSlice';
import vehicleDataReducer from '@store/slices/vehicleDataSlice';
import serviceContractReducer from '@store/slices/serviceContractSlice';
import vehicleDetailsReducer from '@store/slices/vehicleDetails';
import articleReducer from '@store/slices/articlesSlice';
import cartPricesReducer from '@store/slices/cartPrices';
import customerReducer from '@store/slices/customerSlice';
import vehicleModelsReducer from '@store/slices/vehicleModelsSlice';
import modelSeriesMappingReducer from '@store/slices/modelSeriesMappingSlice';
import pCodeMasterListReducer from '@store/slices/pCodeMasterListSlice';
import appReducer from '@store/slices/appSlice';
import pimVehicleListReducer from '@store/slices/pimVehicleList';
import salesWizardReducer from '@store/slices/salesWizardSlice';
import appOrderSliceReducer from '@store/slices/appOrderSlice';
import cartDataReducer from '@store/slices/cartDataSlice';
import leadReducer from '@store/slices/leadSlice';
import factoryEquipmentLevelsReducer from '@store/slices/factoryEquipmentLevelsSlice';
import orderPaneReducer from '@store/slices/orderPaneSlice';
import dealerReducer from '@store/slices/dealerSlice';

const rootReducer = combineReducers({
  employee: employeeReducer,
  configuration: configurationReducer,
  order: orderReducer,
  vehicleConfiguration: vehicleConfigurationReducer,
  vehicleStock: vehicleStockReducer,
  usedVehicleStock: usedVehicleStockReducer,
  vehicleData: vehicleDataReducer,
  serviceContract: serviceContractReducer,
  vehicleDetails: vehicleDetailsReducer,
  article: articleReducer,
  cartPrices: cartPricesReducer,
  customer: customerReducer,
  vehicleModels: vehicleModelsReducer,
  modelSeriesMapping: modelSeriesMappingReducer,
  pCodeMasterList: pCodeMasterListReducer,
  app: appReducer,
  pimVehicleList: pimVehicleListReducer,
  salesWizard: salesWizardReducer,
  appOrder: appOrderSliceReducer,
  cartData: cartDataReducer,
  lead: leadReducer,
  factoryEquipmentLevels: factoryEquipmentLevelsReducer,
  orderPane: orderPaneReducer,
  dealer: dealerReducer,
});

export default rootReducer;
